import React from "react";
import html2pdf from "html2pdf.js";
import { useReactToPrint } from "react-to-print";
import { Button, Box } from "./elements";

export const DownloadAndPrint = ({ handlePrint: unusedHandlePrint, printRef, fileName = "document.pdf" }) => {
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    preserveAfterPrint: true,
    print: (printIframe) =>
      new Promise(() => {
        printIframe.style.display = "none";
        printIframe.contentWindow?.print();
      }),
  });

  const onPrint = (e) => {
    e.preventDefault();
    if (!printRef?.current) {
      console.error("No printRef provided to DownloadAndPrint component");
      return;
    }
    handlePrint();
  };

  const onDownload = (e) => {
    e.preventDefault();
    if (!printRef?.current) {
      console.error("No printRef provided to DownloadAndPrint component");
      return;
    }

    const opt = {
      margin: 10,
      filename: fileName,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(opt).from(printRef.current).save();
  };

  return (
    <div>
      <Box className="mc-invoice-btns" style={{ marginTop: "10px" }}>
        <Button icon={"print"} text={"Print"} className={"btn btn-dark"} onClick={onPrint} />

        <Button icon={"download"} text={"Download"} className={"btn btn-success"} onClick={onDownload} />
      </Box>
    </div>
  );
};
